import { Statuses } from "src/@types/deals";

const T_PREFIX = "deal-card";

export const dealCardTrns = {
  ownerLabel: `${T_PREFIX}.owner-label`,
  agentLabel: `${T_PREFIX}.agent-label`,
};

export const dealStatusesTrns: Record<Statuses, string> = {
  newRequest: `${T_PREFIX}.status.newRequest`,
  pending: `${T_PREFIX}.status.pending`,
  inProgress: `${T_PREFIX}.status.inProgress`,
  done: `${T_PREFIX}.status.done`,
  suspended: `${T_PREFIX}.status.suspended`,
  canceled: `${T_PREFIX}.status.canceled`,
};
